<template>
  <div :class="[$style.wrapper, { [$style.loading]: loading }]">
    <div :class="$style.spinner"></div>
    <div :class="[$style.inner]">
      <slot />
    </div>
  </div>
</template>
<script>
export default {
  name: 'Spinner',
  props: {
    loading: Boolean,
  },
}
</script>
<style lang="scss" module>
@import './Spinner.scss';
</style>
